import React from 'react';
import { set, get } from 'lodash';
import { checkIsNumber, roundOff, shortenStringWithTooltip } from '../../../../../../Components/helper';
import useDetailedPageHook from '../../Hooks/useDetailedPageHook';
import useShowHideSectionHooks from '../../Hooks/useShowHideSectionHooks';
import useValidationHooks from '../../Hooks/useValidationHooks';
import { quantitiesFieldpath, errorpath } from '../../../../ProductCosting/fieldPath';

export const QuantitesExpandView = ({ data, index, isReadonly, expandQuantitiesChild, colourway, sizeRange, lengthRange, productInfoObj }) => {
  const { expandData, isExpanded } = data;
  const { productCostingstate, globalError } = productInfoObj;
  const { isDisabled, hideLengthCol } = useShowHideSectionHooks(productInfoObj);

  const { quantities } = globalError;

  const { calculateQuantities } = useDetailedPageHook(productInfoObj);
  const { onChangeCheckIfErrorExist } = useValidationHooks(productInfoObj);
  const { isBreakdown } = productCostingstate;
  const handleInputChange = async (value, path, colourways) => {
    const copyState = productCostingstate;
    set(copyState, path, value);

    // calculate and manipualte testing module price per unit colour data on quantities (quantituy per siz column)
    // changes
    await calculateQuantities(copyState, colourways);
  };

  const updateError = (path) => onChangeCheckIfErrorExist(path, globalError);

  const isDisable = isDisabled || isReadonly;
  const expandArra = !isBreakdown ? expandData : [expandData[0]];
  return expandArra?.map((element, chindex) => {
    return (
      <tr key={chindex}>
        {chindex === 0 && !isBreakdown && expandArra.length !== 1 ? (
          <td>
            {isExpanded ? (
              <button
                className="btn-up-down"
                onClick={() => {
                  expandQuantitiesChild(index);
                }}
              >
                <span className="icon-new-down-arrow-icon icon-inverse" />
              </button>
            ) : (
              <button
                className="btn-up-down"
                onClick={() => {
                  expandQuantitiesChild(index);
                }}
              >
                <span className="icon-new-down-arrow-icon " />
              </button>
            )}
          </td>
        ) : (
          <td />
        )}
        <td>{colourway?.name}</td>
        <td>{isBreakdown ? Array.isArray(sizeRange) && shortenStringWithTooltip(sizeRange?.map((e) => e?.name).join(' - '), 15) : element?.size || ''}</td>
        {hideLengthCol && (
          <td>
            {isBreakdown
              ? Array.isArray(lengthRange) && shortenStringWithTooltip(lengthRange?.map((e) => e?.name).join(' - '), 15)
              : element?.length?.name || ''}
          </td>
        )}
        <td className="text-left">
          {isDisabled ? (
            roundOff(element?.quantityPerSizCol, 4, true)
          ) : (
            <>
              <input
                onChange={(e) => {
                  if (checkIsNumber(e.target.value)) {
                    handleInputChange(e.target.value, quantitiesFieldpath(index, chindex).EXPAND_QUANTITY_PER_SIZCOL, element?.colourway?._id);
                  }
                  if (get(quantities, `[${index}][${chindex}].quantityPerSizCol`, '')) {
                    updateError(errorpath(index, chindex).QUANTITIES.ERROR_QUANTITY);
                  }
                }}
                readOnly={isDisable}
                value={element.quantityPerSizCol}
                type="text"
                className="form-control text-bordered text-left"
              />
              <span className="error-message">{get(quantities, `[${index}][${chindex}].quantityPerSizCol`, '')}</span>
            </>
          )}
        </td>
      </tr>
    );
  });
};

export default QuantitesExpandView;
